import {httpService} from "@/modules/common/services"

const getCampaigns = async () => {
  try {
    let result = await httpService.get('campaigns',{automatic: true})
    return result
  } catch (e) {
    return e.response.data
  }
}

const getCampaign = async (campaignUid) => {
  try {
    let result = await httpService.get(`campaigns/${campaignUid}`)
    return result
  } catch (e) {
    return e.response.data
  }
}

const saveCampaign = async (campaign) => {
  try {
    let result = await httpService.put(`campaigns/${campaign.uid}`,campaign)
    return result
  } catch (e) {
    return e.response.data
  }
}

const sendCampaign = async (campaign) => {
  try {
    let result = await httpService.post(`campaigns/${campaign.uid}/send_campaign`,campaign)
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const sendMailValidation = async (staffUid) => {
  try {
    let result = await httpService.get(`staffs/send_validation_email`,{id:staffUid})
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const checkTatangoKeyword = async (keyword) => {
  try {
    let result = await httpService.get(`settings/campaign_keyword/check_keyword`,{keyword:keyword})
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const getCampaignSuggestions = async (type) => {
  try {
    let result = await httpService.get('campaigns/suggested_campaigns_by_category',{type:type})
    return {status : 'OK', data: result.data}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const cloneSuggestion = async (campaignUid) => {
  try {
    let result = await httpService.post(`campaigns/${campaignUid}/clone_suggestion`)
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const setTatangoKeyword = async (keyword) => {
  try {
    let result = await httpService.post(`settings/campaign_keyword/set_keyword`,{keyword:keyword})
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const getTatangoKeyword = async () => {
  try {
    let result = await httpService.get(`settings/campaign_keyword`)
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const getCategories = async (type, isAutoCampaign = false) => {
  try {
    const entityType = isAutoCampaign ? 'automatic_campaigns' : 'campaigns'
    let res = await httpService.get(`business/marketing/v1/categories?filter[type]=${type}&filter[entity_type]=${entityType}`, {new_api: true})
    return res.data
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const getCampaignTemplates = async (categoryId, type, page, perPage, isAutoCampaign = false) => {
  try {
    const entityType = isAutoCampaign ? 'automatic_campaigns' : 'campaigns'
    let res = await httpService.get(`business/marketing/v1/campaign_templates?page=${page}&per_page=${perPage}&filter[category]=${categoryId}&filter[campaign_type]=${type}&filter[entity_type]=${entityType}`, {new_api: true})
    return res.data;
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const getCampaignTriggers = () => {
  return [
    {
      value: 'new_customer',
      icon: 'icon-Become-a-client',
      status: 'customer'
    },
    {
      value: 'birthday',
      icon: 'icon-Birthday',
      dateItems: [
        {value: 'day'},
        {value: 'month'},
        {value: 'custom'},
      ]
    },
    {
      value: 'win_back',
      icon: 'icon-Mailbox'
    },
    {
      value: 'new_lead',
      icon: 'icon-New-lead',
      status: 'lead'
    },
    {
      value: 'new_loyal',
      icon: 'icon-Medal',
      status: 'loyal'
    },
    {
      value: 'new_review',
      icon: 'icon-Ranking',
    },
    {
      value: 'custom_date',
      icon: 'icon-Client-date',
      dateItems: [
        {value : 'day'},
        {value: 'month'},
        {value: 'custom'}
      ]
    },
    {
      value: 'first_completed_booking',
      icon: 'icon-calendar-check-light',
      options: ['first_completed', 'first_completed_this_month', 'first_completed_this_quarter']
    }
  ]
}

const setCampaignTrigger = async (campaignUid, trigger) => {
  await httpService.post(`business/marketing/v1/campaign_triggers?campaign_uid=${campaignUid}`, {campaign_trigger_params: trigger, new_api: true});
}

const getCampaignTrigger = async (campaignUid) => {
  const res = await httpService.get(`business/marketing/v1/campaign_triggers/${campaignUid}`, {new_api: true});
  return res.data[0];
}

const updateCampaignTrigger = async (campaignUid, trigger) => {
  await httpService.put(`business/marketing/v1/campaign_triggers/${campaignUid}`, {campaign_trigger_params: trigger, new_api: true});
}

export default {
  getCampaigns,
  getCampaign,
  saveCampaign,
  sendCampaign,
  sendMailValidation,
  checkTatangoKeyword,
  setTatangoKeyword,
  getTatangoKeyword,
  getCampaignSuggestions,
  cloneSuggestion,
  getCategories,
  getCampaignTemplates,
  getCampaignTriggers,
  setCampaignTrigger,
  getCampaignTrigger,
  updateCampaignTrigger
};
